import { motion } from "framer-motion";
import foodImage from "@/assets/images/foodwaste.png";

export default function FoodWasteHero() {
  return (
    <div className="bg-gradient-to-r from-emerald-500 to-teal-700 py-10 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        {/* Left Side - Image with Animation */}
        <motion.div
          className="w-full lg:w-1/2 flex justify-start"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.img
            src={foodImage}
            alt="Food waste illustration"
            className="w-full h-full object-contain"
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.2, ease: "easeOut", delay: 0.2 }}
            whileHover={{ scale: 1.05 }}
            viewport={{ once: true }}
          />
        </motion.div>

        {/* Right Side - Text Animation */}
        <motion.div
          className="w-full lg:w-1/2 flex flex-col justify-center items-end text-right text-white"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-snug tracking-tight">
            Order what you need,{" "}
            <span className="text-green-300">rescue what matters</span>. Save
            money with{" "}
            <span className="text-white border-b-6 border-green-300">
              Mystery Bags
            </span>{" "}
            and help reduce food waste.
          </h2>
        </motion.div>
      </div>
    </div>
  );
}
